exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".JobsList__jobsList--5d1685 {\n  color: #4d4d4d;\n  border-collapse: collapse;\n  width: 100%;\n  line-height: 24px;\n}\n\n.JobsList__header--c31fd4 {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  color: #000000;\n  text-align: left;\n}\n\n.JobsList__headerRow--91006a {\n  border-bottom: 1px solid #9b9b9b;\n  height: 48px;\n}\n\n.JobsList__row--73c4be {\n  border-bottom: 1px solid #cfcfcf;\n  height: 48px;\n}\n\n.JobsList__office--2fa075 {\n  width: 200px;\n}\n\n.JobsList__link--62f42f {\n  text-decoration: none;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #333333;\n}\n\n.JobsList__title--8179e5 {\n  padding-right: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"jobsList": "JobsList__jobsList--5d1685",
	"header": "JobsList__header--c31fd4",
	"headerRow": "JobsList__headerRow--91006a",
	"row": "JobsList__row--73c4be",
	"office": "JobsList__office--2fa075",
	"link": "JobsList__link--62f42f",
	"title": "JobsList__title--8179e5"
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/TeamList/JobsList.css
// module id = 114
// module chunks = 0